var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-success ml-2",attrs:{"target":"_blank","href":_vm.generateUrl()}},[_c('CIcon',{attrs:{"name":"cib-whatsapp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }